import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-compatible-parts-tab',
  standalone: true,
  imports: [CommonModule, TranslocoDirective],
  templateUrl: './compatible-parts-tab.component.html',
  styleUrl: './compatible-parts-tab.component.scss'
})
export class CompatiblePartsTabComponent {}